// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"cffbd247","82":"8b0580dd","214":"d44e97eb","409":"7f09cfa0","453":"4939bcd8","528":"e861eac3","830":"c63b9e0c"}[chunkId] + ".chunk.js";
};